import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
  Tag,
} from "antd";

import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;

class ContractorList extends Component {
  constructor() {
    super();
  }
  state = {
    details: [],
    newdetails: [],
    data: [],
    process: [],
  };

  onChange = async (value) => {
    this.search(value);
  };
  componentDidMount() {
    axios
      .get(`${getServerUrl()}/master/contractor`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        this.setState({ details });
      });
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const data = this.state.details;
    const dataDropDown = this.state.details;

    const columns = [
      {
        title: "Contractor Code",
        dataIndex: "contractor_id",
        key: "contractor_id",
        width: "30%",
        ...this.getColumnSearchProps("contractor_id"),
      },
      {
        title: "Contractor Type",
        dataIndex: "contractor_type",
        key: "contractor_type",
        width: "20%",
        ...this.getColumnSearchProps("contractor_type"),
      },
      {
        title: "Contractor Name",
        dataIndex: "contractor_name",
        key: "contractor_name",
        width: "20%",
        ...this.getColumnSearchProps("contractor_name"),
      },
      {
        title: "Location",
        dataIndex: "city",
        key: "city",
        width: "20%",
        ...this.getColumnSearchProps("city"),
      },
      {
        title: "Phone No",
        dataIndex: "contact_number",
        key: "contact_number",
        width: "20%",
        ...this.getColumnSearchProps("contact_number"),
      },
      /*  {
        title: "Process",
        dataIndex: "processnames",
        key: "processnames",
        width: "20%",
        ...this.getColumnSearchProps("processnames"),
        render: (processnames) => (
          <>
            {processnames.split(",").map((tag) => {
              if (tag) {
                return <Tag>{tag}</Tag>;
              }
            })}
          </>
        ),
      },
*/
      {
        title: "Action",
        dataIndex: "contractor_id",
        key: "contractor_id",
        render: (text, record) => (
          <Space size="middle">
            <NavLink to={"/edit-contractor/" + record.contractor_id}>
              View / Manage
            </NavLink>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
          <Breadcrumb.Item>Contractor Settings</Breadcrumb.Item>
          <Breadcrumb.Item>Contractor List</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            VIEW / MANAGE CONTRACTOR <span>DATA</span>
          </h2>

          <Space></Space>
          <br />
          <Table columns={columns} dataSource={data}></Table>
        </div>
      </div>
    );
  }
}

export default ContractorList;
